/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для баннеров категории УПАКОВКИ
   * Открывает попапы с подкатегориями
   */
  app.CategoryUpakovkaView = app.View.extend({
    el: '.banners-upakovka-container',
    additionalOptions: ['faderView', 'popupElement', 'mainWindow'],
    events: {
      'click .js-item-category': 'renderItems'
    },

    /**
     * @inheritDoc
     */
    run: function () {
      this.initPopup();
    },
  
    /**
     * Открывает попап с подкатегориями конкретных категорий
     */
    initPopup: function () {
        var that = this;
        this.popup = new als.Popup(this.popupElement, this.$('.js-item-category'), this.faderView.$el );
        this.popup.addEventListener(
          als.Popup.EventType.BEFORE_OPEN,
          function () {
            that.faderView.show();
            if( that.mainWindow.$el.width() < 1400 ) {
              that.popupElement.css({
                width: "1021px",
              });
            }

            if( that.mainWindow.$el.width() >= 1400 ) {
              that.popupElement.css({
                width: "1330px",
              });
            }
          }
        );
        this.popup.addEventListener(
          als.Popup.EventType.BEFORE_CLOSE,
          function () {
            that.faderView.hide();
          }
        );
    },

    /**
     * Рендерит картинки подкатегорий в попап
     */
    renderItems: function(ev) {
      this.template = app.helpers.TemplateHelper.getTemplate('#'+$(ev.currentTarget).attr('data-id-popup-template'));
      this.popupElement.find('.popup-wrapper').html(this.template);
    }

  });
})(jQuery);

}.call(window));